module.exports = __webpack_public_path__ + "media/images/test/image-81fd11b694ffde9f1ab33e270aa44c1e.png";